// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y6Zd","label":"styles_label__1a0uK"};